<template>
    <span v-if="saveStatusText != ''"
          class="z-50 fixed top-[150px] left-1/2 transform -translate-x-1/2 ml-4 text-base font-bold border bg-green p-2 rounded"
          :class="{
                  'g--button--green': !isSaving,
                  'g--button--gray opacity-75': isSaving
                }">{{ saveStatusText }}</span>
  <h1 class="text-2xl font-medium mb-10 flex items-center">
    Your account

  </h1>
  <div v-if="loading">
    <Spinner/>
  </div>
  <div v-else-if="user" class="text-sm grid grid-cols-10 pb-10 gap-10">
    <div class="col-span-10 md:col-span-5">
      <div class="grid grid-cols-6 gap-2">
        <div class="col-span-6 sm:col-span-3">
          <label class="g--label mb-1">Full name</label>
          <input @input="debouncedSaveProfile" type="text" v-model="user.fullName" class="g--input">
        </div>
        <div class="col-span-6">
          <div class="g--label mt-4 mb-2">Email address</div>
          <div class="text-sm">{{ user.email }}</div>
          <div class="flex mt-2 items-center gap-2 flex-wrap">
            <a href="/change-email" class=" g--button text-sm">Change your email address</a>
            <a href="/change-password" class="  g--button text-sm">Change your password</a>
          </div>


          <div class="mt-6">
            <div class="flex items-start">
              <div class="flex items-center h-5"><input type="hidden" name="fields[subscribedToWeeklyEmails]" value="">
                <input @change="saveProfile" v-model="user.subscribedToWeeklyEmails" id="subscribedToWeeklyEmails"
                       name="fields[subscribedToWeeklyEmails]"
                       type="checkbox"
                       class="cursor-pointer form-checkbox h-4 w-4 text-teal transition duration-150 ease-in-out"></div>
              <div class="ml-3 text-sm leading-5">
                <label for="subscribedToWeeklyEmails" class="cursor-pointer font-medium text-gray-700">
                  Receive the weekly upcoming classes email.</label>
              </div>
            </div>
          </div>


          <h2 class="mb-2 text-xl mt-8">Communication</h2>
          <div class="">
            <label class="g--label mb-1">Phone number</label>
            <input placeholder="447712345678" @input="debouncedSaveProfile" type="text" v-model="user.phoneNumber" class="g--input">
            <div class="mt-2">Enter your phone number to receive booking confirmations by text.<br/>
            Format: 447712345678</div>
          </div>

          <div class="mt-6">
            <div class="flex items-start">
              <div class="flex items-center h-5"><input type="hidden" name="fields[contactCorporateClass]" value="">
                <input @change="saveProfile" v-model="user.contactCorporateClass" id="contactCorporateClass"
                       name="fields[contactCorporateClass]"
                       type="checkbox"
                       class="cursor-pointer form-checkbox h-4 w-4 text-teal transition duration-150 ease-in-out"></div>
              <div class="ml-3 text-sm leading-5">
                <label for="contactCorporateClass" class="cursor-pointer font-medium text-gray-700">
                  I would like to be contacted for corporate classes.</label>
              </div>
            </div>
          </div>
        </div>


        <!--        <div class="col-span-6 sm:col-span-3">-->
        <!--          <button class="mt-10 g&#45;&#45;button w-full" :class="{-->
        <!--                  'g&#45;&#45;button&#45;&#45;green': !isSaving,-->
        <!--                  'g&#45;&#45;button&#45;&#45;gray opacity-75 cursor-not-allowed': isSaving-->
        <!--                }" :disabled="isSaving" @click="saveProfile">-->
        <!--            {{ saveButtonText }}-->
        <!--          </button>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="col-span-10 md:col-span-5">

      <h2 class="text-xl mb-1">Insurance certificate</h2>

      <div class="bg-green-50 p-4 rounded-lg mb-4">
        <div class="g--copy mb-2">
          <p class="">Please make sure your insurance certificate is in English and covers the following:</p>
        </div>
        <div class="g--copy">
          <ul>
            <li>type of yoga classes covered (needs to state online classes)</li>
            <li>countries covered (country of residency and worldwide, including or excluding US and Canada)</li>
            <li>beginning and end date of the insurance certificate</li>
            <li>type of liability (public liability, professional liability, etc.)</li>
          </ul>
        </div>
      </div>
      <span v-if="user.insuranceCertificate" class="w-full">
            <span class="inline-block text-red bg-red bg-opacity-25 p-1 px-2 rounded text-sm mt-2 mb-2">
              {{ user.insuranceCertificate }}
            </span>
        </span>
      <div v-else>No insurance certificate added. Add one below!</div>
      <div class="">

        <button @click="triggerFileInput('insurance')" class="mt-2 w-full g--button">
            <span v-if="!showDiplomaSaveButton">
              <span v-if="user.insuranceCertificate">Change</span><span v-else>Add an</span> insurance certificate
            </span>
          <span v-else>Try another file</span>
        </button>
        <p class="text-xs mt-4 tracking-wide">Please upload a PDF file &lt; 2mb.</p>
      </div>
      <input type="file" ref="fileInputInsurance" @change="handleFileChangeInsurance" accept="application/pdf"
             class="hidden">


      <label class="g--label mb-1 mt-4">Certificate expiry date *</label>
      <input @change="saveProfile" type="date" v-model="user.insuranceCertificateExpiryDate" class="g--input">

      <label class="g--label mb-1 mt-4">Certificate issuing country *</label>
      <select @change="saveProfile" type="text" v-model="user.insuranceCertificateIssuingCountry"
              class="g--select g--input"
              placeholder="e.g. Netherlands, Germany, etc.">
        <option value="">Select a country</option>

        <!--        <option :key="countries['GB'].code" :value="countries['GB'].code">-->
        <!--          {{ countries['GB'].name }}-->
        <!--        </option>-->
        <!--        <option :key="countries['US'].code" :value="countries['US'].code">-->
        <!--          {{ countries['US'].name }}-->
        <!--        </option>-->
        <option disabled>──────────</option>
        <option v-for="country in countries" :key="country.code" :value="country.code">
          {{ country.name }}
        </option>
      </select>


      <div class="mt-2">
        <div class="g--label mb-1 mt-4">Insurance Coverage *</div>
        <div class="flex flex-col gap-y-2 items-start gap-6">
          <div class="flex items-center">
            <input
                @change="saveProfile"
                v-model="user.insuranceLocation"
                id="insuranceLocationWorldExceptUs"
                name="fields[insuranceLocation]"
                type="radio"
                value="worldExceptUs"
                class="cursor-pointer form-radio h-4 w-4 text-teal transition duration-150 ease-in-out"
            />
            <label
                for="insuranceLocationWorldExceptUs"
                class="cursor-pointer font-medium text-gray-700 ml-2"
            >
              World except US & Canada
            </label>
          </div>

          <div class="flex items-center">
            <input
                @change="saveProfile"
                v-model="user.insuranceLocation"
                id="insuranceLocationWorldIncludingUs"
                name="fields[insuranceLocation]"
                type="radio"
                value="worldIncludingUs"
                class="cursor-pointer form-radio h-4 w-4 text-teal transition duration-150 ease-in-out"
            />
            <label
                for="insuranceLocationWorldIncludingUs"
                class="cursor-pointer font-medium text-gray-700 ml-2"
            >
              World including US & Canada
            </label>
          </div>

          <div class="flex items-center">
            <input
                @change="saveProfile"
                v-model="user.insuranceLocation"
                id="insuranceLocationNotInsured"
                name="fields[insuranceLocation]"
                type="radio"
                value="notInsured"
                class="cursor-pointer form-radio h-4 w-4 text-teal transition duration-150 ease-in-out"
            />
            <label
                for="insuranceLocationNotInsured"
                class="cursor-pointer font-medium text-gray-700 ml-2"
            >
              I am not insured yet
            </label>
          </div>
        </div>
      </div>


      <div class="text-xl mt-6 mb-1">Yoga diploma</div>
      <span v-if="user.yogaDiploma" class="w-full">
            <span class="inline-block text-red bg-red bg-opacity-25 p-1 px-2 rounded text-sm mt-2 mb-2">
              {{ user.yogaDiploma }}
            </span>
        </span>
      <div v-else>No diploma added. Add one below!</div>
      <div class="">
        <button @click="triggerFileInput('diploma')" class="mt-2 w-full g--button">
            <span v-if="!showDiplomaSaveButton">
              <span v-if="user.yogaDiploma">Change</span><span v-else>Add a</span> yoga diploma
            </span>
          <span v-else>Try another file</span>
        </button>
        <p class="text-xs mt-4 tracking-wide">Please upload a PDF file &lt; 2mb.</p>
      </div>
      <input type="file" ref="fileInputDiploma" @change="handleFileChangeDiploma" accept="application/pdf"
             class="hidden">


    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Spinner from './Spinner.vue';
import Editor from './Editor.vue'
import Tooltip from './Tooltip.vue'

import { debounce } from 'lodash';

const loading = ref(true);
const user = ref(null);
const saveButtonText = ref('Save changes');
const saveStatusText = ref('');
const isSaving = ref(false);
const countries = ref([]);

const showDiplomaSaveButton = ref(false);

const fileInputDiploma = ref(null);
const fileInputInsurance = ref(null);

const debouncedSaveProfile = debounce(() => saveProfile(), 500);

onMounted(() => {
  loadUser();
  loadCountries();
});

const loadUser = async () => {
  const response = await fetch(`/api/teachers/self`);
  user.value = await response.json();
  console.log(user.value);
  loading.value = false;
};

const loadCountries = async () => {
  const response = await fetch(`/api/teachers/countries`);
  countries.value = await response.json();
  console.log(countries.value);
};


const saveProfile = async () => {
  console.log(user.value.allStyles);
  isSaving.value = true;
  saveButtonText.value = 'Saving...';
  saveStatusText.value = 'Saving...';
  const formData = new FormData();
  formData.append('fullName', user.value.fullName);
  formData.append('fields[phoneNumber]', user.value.phoneNumber);
  // enter today's date as lastProfileCertificatePageUpdate including time
  formData.append('fields[lastProfileCertificatePageUpdate]', new Date().toISOString());
  formData.append('fields[subscribedToWeeklyEmails]', user.value.subscribedToWeeklyEmails ? 1 : 0);
  formData.append('fields[contactCorporateClass]', user.value.contactCorporateClass ? 1 : 0);
  formData.append('fields[insuranceCertificateExpiryDate]', user.value.insuranceCertificateExpiryDate);
  formData.append('fields[insuranceCertificateIssuingCountry]', user.value.insuranceCertificateIssuingCountry);
  formData.append('fields[insuranceLocation]', user.value.insuranceLocation);
  formData.append('userId', user.value.userId);
  formData.append(csrfTokenName, csrfTokenValue);

  fetch('?action=users/save-user', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        console.log(response);
        saveButtonText.value = 'Saved!';
        saveStatusText.value = 'Saved!';
        setTimeout(() => {
          saveButtonText.value = 'Save changes';
          saveStatusText.value = '';
          isSaving.value = false;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error saving profile:', error);
        saveButtonText.value = 'Save changes';
        saveStatusText.value = 'Error saving profile';
        isSaving.value = false;
      });
};


const triggerFileInput = (type) => {
  if (type == 'diploma') {
    fileInputDiploma.value.click();
  } else if (type == 'insurance') {
    fileInputInsurance.value.click();
  }
};


const handleFileChangeInsurance = (event) => {
  const file = event.target.files[0];
  if (file) {
    // Create a temporary URL for preview
    user.value.photo = URL.createObjectURL(file);
    user.value.photoFile = file;
    // showDiplomaSaveButton.value = true;
    uploadFile('insurance');
  }
};
const handleFileChangeDiploma = (event) => {
  const file = event.target.files[0];
  if (file) {
    // Create a temporary URL for preview
    user.value.photo = URL.createObjectURL(file);
    user.value.photoFile = file;
    // showDiplomaSaveButton.value = true;
    uploadFile('diploma');
  }
};

// Implement photo upload function
const uploadFile = async (type) => {
  const reader = new FileReader();
  reader.readAsDataURL(user.value.photoFile);

  reader.onload = e => {

    const formData = new FormData();
    // formData.append('photo', user.value.photoFile);
    if (type == 'diploma') {
      formData.append('fields[yogaDiploma][]', user.value.photoFile);
    } else if (type == 'insurance') {
      formData.append('fields[insuranceCertificate][]', user.value.photoFile);
    }
    formData.append('userId', user.value.userId);
    formData.append(csrfTokenName, csrfTokenValue);


    fetch('?action=users/save-user', {
      method: 'post',
      headers: {
        // 'Content-type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },

      processData: false,
      contentType: false,
      body: formData
      //   body: JSON.stringify(data),
    })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          console.log(response);
          if (response.errors && response.errors.photo) {
            alert('Your photo is too big. Please upload a file < 2mb.');
          }
          showDiplomaSaveButton.value = false;
          loadUser()
          // saved.value = true;
          // setTimeout(() => {
          //   saved.value = false;
          // }, 2000);
        })
        .catch((error) => {
          alert('Your photo is too big. Please upload a file < 2mb.');
          // that.uploading = false;
        });
  }

};
</script>
